"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversationMediaConfigQuerySchema = exports.conversationMediaConfigSchema = exports.markConversationReadRequestSchema = exports.conversationFormOptionsResponseSchema = exports.inboundConversationMessageResponseSchema = exports.inboundConversationMessageRequestSchema = exports.createConversationLeadResponseSchema = exports.createConversationLeadRequestSchema = exports.linkConversationRequestSchema = exports.assignConversationRequestSchema = exports.updateConversationStatusRequestSchema = exports.retryConversationMessageRequestSchema = exports.createConversationMessageRequestSchema = exports.createTeamConversationRequestSchema = exports.createConversationRequestSchema = exports.conversationListResponseSchema = exports.conversationListQuerySchema = exports.conversationDetailSchema = exports.conversationActivitySchema = exports.conversationSchema = exports.conversationContextSchema = exports.conversationExternalThreadSummarySchema = exports.conversationMessageSchema = exports.conversationParticipantSchema = exports.conversationAttachmentInputSchema = exports.conversationAttachmentSchema = exports.conversationMessageStatusSchema = exports.conversationMessageDirectionSchema = exports.conversationStatusSchema = exports.conversationChannelSchema = exports.conversationKindSchema = exports.messageIdSchema = exports.conversationIdSchema = void 0;
const zod_1 = require("zod");
const lead_1 = require("./lead");
const pagination_1 = require("./pagination");
exports.conversationIdSchema = zod_1.z.string().uuid();
exports.messageIdSchema = zod_1.z.string().uuid();
exports.conversationKindSchema = zod_1.z.enum(["CUSTOMER", "TEAM"]);
exports.conversationChannelSchema = zod_1.z.enum([
    "EMAIL",
    "SMS",
    "WEB_CHAT",
    "MESSAGING",
    "TEAM",
]);
exports.conversationStatusSchema = zod_1.z.enum([
    "OPEN",
    "PENDING",
    "CLOSED",
    "SPAM",
]);
exports.conversationMessageDirectionSchema = zod_1.z.enum([
    "INBOUND",
    "OUTBOUND",
    "INTERNAL",
]);
exports.conversationMessageStatusSchema = zod_1.z.enum([
    "QUEUED",
    "SENT",
    "DELIVERED",
    "FAILED",
    "RECEIVED",
]);
exports.conversationAttachmentSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    fileName: zod_1.z.string().min(1).max(255),
    contentType: zod_1.z.string().min(1).max(160),
    sizeBytes: zod_1.z.number().int().nonnegative(),
    storageKey: zod_1.z.string().min(1).max(512),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.conversationAttachmentInputSchema = zod_1.z.object({
    fileName: zod_1.z.string().trim().min(1).max(255),
    contentType: zod_1.z.string().trim().min(1).max(160),
    sizeBytes: zod_1.z.number().int().nonnegative(),
    storageKey: zod_1.z.string().trim().min(1).max(512),
});
exports.conversationParticipantSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: zod_1.z.enum(["CUSTOMER", "LEAD", "STAFF", "EXTERNAL"]),
    membershipId: zod_1.z.string().uuid().nullable().optional(),
    displayName: zod_1.z.string().nullable(),
    email: zod_1.z.string().email().nullable(),
    phone: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.conversationMessageSchema = zod_1.z.object({
    id: exports.messageIdSchema,
    conversationId: exports.conversationIdSchema,
    channel: exports.conversationChannelSchema,
    direction: exports.conversationMessageDirectionSchema,
    status: exports.conversationMessageStatusSchema,
    sender: zod_1.z.string().nullable(),
    recipient: zod_1.z.string().nullable(),
    subject: zod_1.z.string().nullable(),
    body: zod_1.z.string().min(1),
    provider: zod_1.z.string().nullable(),
    providerMessageId: zod_1.z.string().nullable(),
    retryOfMessageId: exports.messageIdSchema.nullable(),
    safeError: zod_1.z.string().nullable(),
    actorMembershipId: zod_1.z.string().uuid().nullable(),
    attachments: zod_1.z.array(exports.conversationAttachmentSchema),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    seenAt: zod_1.z.string().datetime({ offset: true }).nullable().optional(),
    sentAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    deliveredAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    failedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    providerOccurredAt: zod_1.z
        .string()
        .datetime({ offset: true })
        .nullable()
        .optional(),
    ingestedAt: zod_1.z.string().datetime({ offset: true }).optional(),
    providerSequence: zod_1.z.string().max(255).nullable().optional(),
});
exports.conversationExternalThreadSummarySchema = zod_1.z.object({
    provider: zod_1.z.string().trim().min(1).max(80),
    connectionId: zod_1.z.string().uuid(),
    replySupported: zod_1.z.boolean(),
});
exports.conversationContextSchema = zod_1.z.object({
    leadId: zod_1.z.string().uuid().nullable(),
    customerId: zod_1.z.string().uuid().nullable(),
    serviceLocationId: zod_1.z.string().uuid().nullable(),
    jobId: zod_1.z.string().uuid().nullable(),
    estimateId: zod_1.z.string().uuid().nullable(),
    invoiceId: zod_1.z.string().uuid().nullable(),
});
exports.conversationSchema = zod_1.z.object({
    id: exports.conversationIdSchema,
    businessId: zod_1.z.string().uuid(),
    kind: exports.conversationKindSchema.default("CUSTOMER"),
    channel: exports.conversationChannelSchema,
    status: exports.conversationStatusSchema,
    subject: zod_1.z.string().nullable(),
    contactName: zod_1.z.string().nullable(),
    contactEmail: zod_1.z.string().email().nullable(),
    contactPhone: zod_1.z.string().nullable(),
    assignedToMembershipId: zod_1.z.string().uuid().nullable(),
    assignedToName: zod_1.z.string().nullable(),
    unreadCount: zod_1.z.number().int().nonnegative(),
    lastMessagePreview: zod_1.z.string().nullable(),
    lastMessageAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    context: exports.conversationContextSchema,
    externalThread: exports.conversationExternalThreadSummarySchema.nullable().optional(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
    closedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
});
exports.conversationActivitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: zod_1.z.enum(["CREATED", "ASSIGNED", "STATUS_CHANGED", "LINKED", "READ"]),
    actorMembershipId: zod_1.z.string().uuid().nullable(),
    title: zod_1.z.string().min(1).max(240),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
});
exports.conversationDetailSchema = exports.conversationSchema.extend({
    participants: zod_1.z.array(exports.conversationParticipantSchema),
    messages: zod_1.z.array(exports.conversationMessageSchema),
    activities: zod_1.z.array(exports.conversationActivitySchema),
});
const queryBooleanSchema = zod_1.z
    .enum(["true", "false"])
    .transform((value) => value === "true")
    .optional();
exports.conversationListQuerySchema = pagination_1.paginationQuerySchema.extend({
    search: zod_1.z.string().trim().max(160).optional(),
    kind: exports.conversationKindSchema.optional(),
    status: exports.conversationStatusSchema.optional(),
    channel: exports.conversationChannelSchema.optional(),
    assignedToMembershipId: zod_1.z.string().uuid().optional(),
    unassigned: queryBooleanSchema,
    unread: queryBooleanSchema,
});
exports.conversationListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.conversationSchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema,
});
exports.createConversationRequestSchema = zod_1.z
    .object({
    channel: zod_1.z.enum(["EMAIL", "SMS"]),
    subject: zod_1.z.string().trim().max(240).optional(),
    contactName: zod_1.z.string().trim().max(160).optional(),
    contactEmail: zod_1.z.string().trim().toLowerCase().email().max(320).optional(),
    contactPhone: zod_1.z.string().trim().max(32).optional(),
    assignedToMembershipId: zod_1.z.string().uuid().optional(),
})
    .refine((value) => value.contactEmail || value.contactPhone, {
    path: ["contactEmail"],
    message: "An email address or phone number is required.",
})
    .superRefine((value, context) => {
    if (value.channel === "EMAIL" && !value.contactEmail) {
        context.addIssue({
            code: "custom",
            path: ["contactEmail"],
            message: "Email conversations require an email address.",
        });
    }
    if (value.channel === "SMS" && !value.contactPhone) {
        context.addIssue({
            code: "custom",
            path: ["contactPhone"],
            message: "SMS conversations require a phone number.",
        });
    }
});
exports.createTeamConversationRequestSchema = zod_1.z
    .object({
    idempotencyKey: zod_1.z.string().uuid(),
    title: zod_1.z.string().trim().min(1).max(160),
    participantMembershipIds: zod_1.z.array(zod_1.z.string().uuid()).min(1).max(100),
    initialMessage: zod_1.z.string().trim().min(1).max(20_000).optional(),
})
    .transform((value) => ({
    ...value,
    participantMembershipIds: [...new Set(value.participantMembershipIds)],
}));
exports.createConversationMessageRequestSchema = zod_1.z.object({
    idempotencyKey: zod_1.z.string().uuid(),
    direction: zod_1.z.enum(["OUTBOUND", "INTERNAL"]).default("OUTBOUND"),
    subject: zod_1.z.string().trim().max(240).optional(),
    body: zod_1.z.string().trim().min(1).max(20_000),
    recipient: zod_1.z.string().trim().max(320).optional(),
    attachments: zod_1.z.array(exports.conversationAttachmentInputSchema).max(20).default([]),
});
exports.retryConversationMessageRequestSchema = zod_1.z.object({
    idempotencyKey: zod_1.z.string().uuid(),
});
exports.updateConversationStatusRequestSchema = zod_1.z.object({
    status: exports.conversationStatusSchema,
});
exports.assignConversationRequestSchema = zod_1.z.object({
    assignedToMembershipId: zod_1.z.string().uuid().nullable(),
});
exports.linkConversationRequestSchema = zod_1.z
    .object({
    leadId: zod_1.z.string().uuid().optional(),
    customerId: zod_1.z.string().uuid().optional(),
    serviceLocationId: zod_1.z.string().uuid().optional(),
    jobId: zod_1.z.string().uuid().optional(),
    estimateId: zod_1.z.string().uuid().optional(),
    invoiceId: zod_1.z.string().uuid().optional(),
})
    .refine((value) => Object.values(value).some((item) => item !== undefined), {
    message: "At least one conversation link is required.",
});
exports.createConversationLeadRequestSchema = zod_1.z.object({
    lead: lead_1.createLeadRequestSchema,
});
exports.createConversationLeadResponseSchema = zod_1.z.object({
    conversation: exports.conversationDetailSchema,
    lead: lead_1.leadDetailSchema,
    warnings: zod_1.z.array(lead_1.leadWarningSchema),
    idempotentReplay: zod_1.z.boolean(),
});
exports.inboundConversationMessageRequestSchema = zod_1.z.object({
    provider: zod_1.z.string().trim().min(1).max(80),
    providerMessageId: zod_1.z.string().trim().min(1).max(255),
    businessId: zod_1.z.string().uuid(),
    channel: zod_1.z.enum(["EMAIL", "SMS", "WEB_CHAT", "MESSAGING"]),
    sender: zod_1.z.string().trim().min(1).max(320),
    recipient: zod_1.z.string().trim().min(1).max(320),
    subject: zod_1.z.string().trim().max(240).optional(),
    body: zod_1.z.string().trim().min(1).max(20_000),
    contactName: zod_1.z.string().trim().max(160).optional(),
    receivedAt: zod_1.z.string().datetime({ offset: true }).optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).default({}),
    attachments: zod_1.z.array(exports.conversationAttachmentInputSchema).max(20).default([]),
    providerThread: zod_1.z
        .object({
        connectionId: zod_1.z.string().uuid(),
        providerEventId: zod_1.z.string().trim().min(1).max(255).optional(),
        externalThreadId: zod_1.z.string().trim().min(1).max(255),
        externalLeadId: zod_1.z.string().trim().min(1).max(255).nullable().optional(),
        externalAccountId: zod_1.z.string().trim().min(1).max(64).nullable().optional(),
        replySupported: zod_1.z.boolean().default(true),
        providerOccurredAt: zod_1.z.string().datetime({ offset: true }).optional(),
        providerSequence: zod_1.z.string().trim().min(1).max(255).optional(),
    })
        .optional(),
});
exports.inboundConversationMessageResponseSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    duplicate: zod_1.z.boolean(),
    conversationId: zod_1.z.string().uuid(),
    messageId: zod_1.z.string().uuid(),
});
exports.conversationFormOptionsResponseSchema = zod_1.z.object({
    currentMembershipId: zod_1.z.string().uuid().nullable(),
    teamMembers: zod_1.z.array(zod_1.z.object({
        membershipId: zod_1.z.string().uuid(),
        displayName: zod_1.z.string(),
    })),
    leads: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        displayName: zod_1.z.string(),
        summary: zod_1.z.string(),
    })),
    customers: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        displayName: zod_1.z.string(),
        locations: zod_1.z.array(zod_1.z.object({
            id: zod_1.z.string().uuid(),
            name: zod_1.z.string(),
            addressLine1: zod_1.z.string(),
            city: zod_1.z.string(),
            state: zod_1.z.string(),
        })),
    })),
    jobs: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        jobNumber: zod_1.z.number().int().positive(),
        summary: zod_1.z.string(),
    })),
    estimates: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        estimateNumber: zod_1.z.number().int().positive(),
    })),
    invoices: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        invoiceNumber: zod_1.z.number().int().positive(),
    })),
});
// Only explicitly visible messages produce read receipts. An omitted list keeps legacy unread clearing.
exports.markConversationReadRequestSchema = zod_1.z.object({
    messageIds: zod_1.z.array(exports.messageIdSchema).min(1).max(250).optional(),
});
// Publishable client identifier for direct GIPHY requests, never a provider secret.
exports.conversationMediaConfigSchema = zod_1.z.object({
    giphyApiKey: zod_1.z.string().min(1).nullable(),
});
exports.conversationMediaConfigQuerySchema = zod_1.z.object({
    platform: zod_1.z.enum(["WEB", "ANDROID", "IOS"]).default("WEB"),
});
//# sourceMappingURL=conversation.js.map